import { PDFViewer } from "@react-pdf/renderer";
import { Button, Col, Row } from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiURL, fetchApi, postApi } from "../../../redux/api"; // Ensure this supports FormData
import { Routes } from "../../../routes";
import moment from "moment-timezone";
import { PaymentVoucherPdf } from "./PVPDFNew";
import { useSelector } from "react-redux";

const UpdloadPvPDF = () => {
  const { pv_code } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [pvList, setPvList] = useState([]);
  const [taxesApplied, setTaxesApplied] = useState([]);
  const mda = useSelector((state) => state.auth.user);
  const imageId = moment().format("YYYYMMDDhhmmss");

  useEffect(() => {
    if (pv_code) {
      setLoading(true);
      fetchApi(`get_new_pv_by_mda?query_type=get_upload_pv&id=${pv_code}`)
        .then((data) => {
          setPvList(data.result || []);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [pv_code]);

  useEffect(() => {
    if (pvList?.length && pvList[0]?.pv_code) {
      setLoading(true);
      fetchApi(`getTaxesAppliedByPv?pv_code=${pvList[0].pv_code}`)
        .then((data) => {
          setTaxesApplied(data?.data || []);
        })
        .catch((error) => {
          console.error("Error fetching taxes applied:", error);
        })
        .finally(() => setLoading(false));
    }
  }, [pvList]);

  if (!pv_code) {
    return <p>Error: Missing MDA Code</p>;
  }

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    console.log("Selected File:", selectedFile);

    if (selectedFile) {
      // Check file size (1MB = 1048576 bytes)
      if (selectedFile.size > 1048576) {
        setErrorMessage("File size exceeds 1 MB limit");
        setFile(null);
        return;
      }
      setErrorMessage("");
      setFile(selectedFile);
    }
  };

  const handleSubmit = () => {
    if (!file) {
      alert("No file selected. Please upload a file first.");
      return;
    }

    if (!pvList || pvList.length === 0) {
      alert("PV list is empty. Please fetch the data before submitting.");
      return;
    }

    setLoading(true);

    const form = {
      mda_name: pvList[0].mda_name || "",
      mda_code: pvList[0].mda_code || "",
      mda_economic_code: pvList[0].economic_code || "",
      approved_by: pvList[0].approved_by || "",
      approval: file ? "approved" : "not approved",
      pv_code: pvList[0].pv_code || "",
      imageId: imageId,
      approval_no: pvList[0].approval_no || "",
    };

    const formData = new FormData();
    formData.append("form", JSON.stringify(form));

    // Append the selected file if available
    if (file) {
      formData.append("files", file);
    }

    const logFormData = (formData) => {
      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
    };

    logFormData(formData);

    fetch(`${apiURL}/post_images_pv`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);

        alert("Upload successful!");
        navigate(Routes.pv.pvCheckedIndex);
        console.log();
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error uploading file:", error);
        setErrorMessage("An error occurred while uploading the file.");
      });
  };

  const style = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
    cursor: "pointer",
  };

  return (
    <div>
      <h4>Upload PV PDF</h4>
      {/* {JSON.stringify({pvList, taxesApplied})} */}
      <Row>
        <Col md={8}>
          <PDFViewer
            style={{
              width: "100%",
              height: 1000,
            }}
          >
            <PaymentVoucherPdf mda={mda} form={pvList} taxesApplied={taxesApplied}/>
          </PDFViewer>
        </Col>
        <Col md={4}>
          <div className="mv-2">
            <h4>Upload Attachment</h4>
            <div style={style}>
              <input
                type="file"
                onChange={handleFileChange}
                accept="application/pdf,image/jpeg,image/png"
                style={{ display: "none" }}
                id="file-input"
              />
              <label
                htmlFor="file-input"
                style={{ cursor: "pointer", margin: 0 }}
              >
                <p>Drag 'n' drop some files here, or click to select files</p>
              </label>
            </div>
            <p style={{ color: "red", marginTop: 6 }}>
              <b>Note:</b> Ensure that the file size does not exceed 1 MB.
            </p>
            {/* {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>} */}
            {file && (
              <aside>
                <h4>Selected File</h4>
                <ul>
                  <li key={file.name}>
                    {file.name} - {Math.round(file.size / 1024)} KB
                  </li>
                </ul>
              </aside>
            )}
          </div>
          <Button
            variant="success"
            className="mt-3"
            disabled={loading || !file}
            onClick={handleSubmit}
          >
            {loading ? "Processing..." : "Upload Signed PV"}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default UpdloadPvPDF;
